import React from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import img_1 from "../../assets/img/image-1.jpg";
import img_2 from "../../assets/img/image-2.jpg";
import img_3 from "../../assets/img/image-3.jpg";


export default function Post(props) {
  const navigate = useNavigate();
  let post = [
    {
      id: 1,
      title:
        "Shandrani Beachcomber Resort & Spa, un nouveau concept dès novembre 2020",
      date: "2020-06-25",
      image: img_1,
      description: ` Lorem ipsum dolor sit amet, consectetur adipisicing elit.
            Inventore sed consequuntur error repudiandae numquam deserunt
            quisquam repellat libero asperiores earum nam nobis`,
    },
    {
      id: 2,
      title:
        "Energie renouvelable : Beachcomber Resorts & Hotels se dote de panneaux photovoltaïques",
      date: "2020-05-18",
      image: img_2,
      description: ` Lorem ipsum dolor sit amet, consectetur adipisicing elit.
            Inventore sed consequuntur error repudiandae numquam deserunt
            quisquam repellat libero asperiores earum nam nobis`,
    },
    {
      id: 3,
      title: "Florence Decotter nommée Hotel Manager du Mauricia Beachcomber",
      date: "2020-06-25",
      image: img_3,
      description: ` Lorem ipsum dolor sit amet, consectetur adipisicing elit.
            Inventore sed consequuntur error repudiandae numquam deserunt
            quisquam repellat libero asperiores earum nam nobis`,
    },
    {
      id: 4,
      title:
        "Shandrani Beachcomber Resort & Spa, un nouveau concept dès novembre 2020",
      date: "2020-06-25",
      image: img_1,
      description: ` Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Inventore sed consequuntur error repudiandae numquam deserunt
              quisquam repellat libero asperiores earum nam nobis`,
    },
    {
      id: 5,
      title:
        "Energie renouvelable : Beachcomber Resorts & Hotels se dote de panneaux photovoltaïques",
      date: "2020-05-18",
      image: img_2,
      description: ` Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Inventore sed consequuntur error repudiandae numquam deserunt
              quisquam repellat libero asperiores earum nam nobis`,
    },
    {
        id: 6,
        title: "Florence Decotter nommée Hotel Manager du Mauricia Beachcomber",
        date: "2020-06-25",
        image: img_3,
        description: ` Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Inventore sed consequuntur error repudiandae numquam deserunt
              quisquam repellat libero asperiores earum nam nobis`,
      },
      {
        id: 7,
        title:
          "Shandrani Beachcomber Resort & Spa, un nouveau concept dès novembre 2020",
        date: "2020-06-25",
        image: img_1,
        description: ` Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Inventore sed consequuntur error repudiandae numquam deserunt
              quisquam repellat libero asperiores earum nam nobis`,
      },
  ];

  const header = (src) => <img alt="post-img" src={src} className="post-img" />;
  const footer = (id) => {
    return (
      <>
        <a href="/" onClick={(e) => handleClick(e, id)}>
          Continue reading...
        </a>
      </>
    );
  };

  const title = (title) => {
    return <p className="p-card-title post-title">{title}</p>;
  };

  const subTitle = (title) => {
    return (
      <p className="p-card-subtitle ">
        <i className="pi pi-calendar"></i> {title}
      </p>
    );
  };

  const handleClick = (e, id) => {
    e.preventDefault();
    navigate("/blog/" + id);
  };

  const PostTemplate = ({ item }) => {
    return (
      <a
        href="/"
        className="post-item"
        onClick={(e) => handleClick(e, item.id)}
      >
        <div className="card flex justify-content-center">
          <Card
            title={title(item.title)}
            subTitle={subTitle(item.date)}
            footer={footer(item.id)}
            header={header(item.image)}
            className="md:w-25rem "
          >
            <p className="m-0">{item.description} ...</p>
          </Card>
        </div>
      </a>
    );
  };
  return (
    <div className="row ">
      {post.map((item, index) => {
        return (
          <div className="col-12 col-sm-4 my-5 ">
            <PostTemplate item={item} />
          </div>
        );
      })}
      {/* <DataScroller value={post} itemTemplate={PostTemplate} rows={5} buffer={0.4} header="List of Products" /> */}
    </div>
  );
}
